import httpClient from 'api/httpClient';
import i18next from 'i18next';

export default () => {
  httpClient.interceptors.request.use((request) => {
    request.params = { ...request.params, locale: i18next.language };
    return request;
  });
};
